module.exports = __webpack_public_path__ + "static/media/plane.1fc1f8e8.png";